import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Timing from './Timing';
import T from 'i18n-react';
import type { MealGroupingType, MealProps } from '../index';
import camelCase from 'lodash/camelCase';
import { PAYERS, TIMINGS, MEAL_GROUPINGS } from '../constants';

const useStyles = makeStyles((theme) => ({
  itemContainer: {
    marginBottom: theme.spacing(3),
  },
  timingContainer: {
    marginBottom: theme.spacing(1),
  },
  text: {
    fontSize: theme.typography.pxToRem(14),
    marginBottom: theme.spacing(0.5),
  },
}));

type MealComponentProps = MealProps & {
  mealGrouping: MealGroupingType,
};

const Meal = ({
  timing,
  payer,
  kind,
  description,
  mealGrouping,
}: MealComponentProps) => {
  const classes = useStyles();

  if (
    timing === TIMINGS.NOON &&
    [MEAL_GROUPINGS.ALL, MEAL_GROUPINGS.MORNING_NOON].includes(mealGrouping)
  )
    return null;
  if (
    timing === TIMINGS.EVENING &&
    [
      MEAL_GROUPINGS.ALL,
      MEAL_GROUPINGS.MORNING_EVENING,
      MEAL_GROUPINGS.NOON_EVENING,
    ].includes(mealGrouping)
  )
    return null;

  return (
    <Grid item xs={12} container className={classes.itemContainer}>
      <Grid item xs={12} className={classes.timingContainer}>
        <Timing timing={timing} mealGrouping={mealGrouping} />
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.text}>
          {T.translate(`planPage.planMeals.kinds.${camelCase(kind)}`)}
          {payer === PAYERS.PARTICIPANT &&
            T.translate('planPage.planMeals.participantPays')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.text}>{description}</Typography>
      </Grid>
    </Grid>
  );
};

export default Meal;
